module.exports = __webpack_public_path__ + "static/img/section_advantage.4e71ab8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/section_advantage.png
// module id = zCQe
// module chunks = 0